// extracted by mini-css-extract-plugin
export default {"container":"WallboardTop_container__gRWYl","serviceBoards":"WallboardTop_serviceBoards__T9oB2"};